export const VIEW_CHILD_TAB = {
  BUDGET_PACING: {
    value: 'budget-pacing',
    label: 'Budget Pacing',
  },
  PERFORMANCE: {
    value: 'performance',
    label: 'Performance',
  },
};

export const VIEW_CHILD_TAB_OPTIONS = Object.values(VIEW_CHILD_TAB)

